import styled from 'styled-components';
import { cornerRadiusM, dropShadowM, spaceXL, xdlColorBackground, } from '@xingternal/tokens';
import { zIndexElevatedLayer5 } from '@xingternal/layout-tokens';
// *** Components ***
const Wrapper = styled.div `
  background: ${xdlColorBackground};
  border-radius: ${cornerRadiusM};
  box-shadow: ${dropShadowM};
  padding-bottom: ${spaceXL};
  padding-left: ${spaceXL};
  padding-right: ${spaceXL};
  padding-top: ${spaceXL};
  position: absolute;
  z-index: ${zIndexElevatedLayer5};
`;
export const Styled = {
    Wrapper,
};
//# sourceMappingURL=pop-over.styles.js.map